export default "__VITE_ASSET__6c4e5a4e__"